import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useBusiness } from "../../context/BusinessContext";
import BusinessDashboard from "./BusinessDashboard";
import Customers from "./Customers";
import Invoices from "./Invoices";
import InvoiceForm from "./InvoiceForm";
import InvoicePrint from "./InvoicePrint";
import WorkOrders from "./WorkOrders";
import Loads from "./Loads";
import Expenses from "../Expenses";
import Fleet from "./Fleet";
import FleetUnitDetail from "./FleetUnitDetail";
import Parts from "./Parts";
import CustomerProfitability from "./CustomerProfitability";

/**
 * Sub-router for a single business (Repair or Trucking).
 * Mounted at /repair/* or /trucking/* — children paths are relative.
 */
export default function BusinessRouter({ businessId, type }) {
  const { setActive, active } = useBusiness();
  React.useEffect(() => {
    if (active !== businessId) setActive(businessId);
  }, [businessId, active, setActive]);

  const jobsResource = type === "repair" ? "work-orders" : "loads";
  const JobsPage = type === "repair" ? WorkOrders : Loads;

  return (
    <Routes>
      <Route index element={<BusinessDashboard businessId={businessId} type={type} extraResource={jobsResource} />} />
      <Route path="customers" element={<Customers preferredBusinessId={businessId} />} />
      <Route path={type === "repair" ? "work-orders" : "loads"} element={<JobsPage businessId={businessId} />} />
      <Route path="invoices" element={<Invoices businessId={businessId} />} />
      <Route path="invoices/new" element={<InvoiceForm businessId={businessId} returnPath="../invoices" />} />
      <Route path="invoices/:invoiceId/print" element={<InvoicePrint returnPath="../../invoices" />} />
      <Route path="invoices/:invoiceId" element={<InvoiceForm businessId={businessId} returnPath="../../invoices" />} />
      <Route path="expenses" element={<Expenses scopeBusinessId={businessId} />} />
      <Route path="customer-pnl" element={<CustomerProfitability businessId={businessId} title="Customer Profitability" subtitle={`Who's making you the most money — ${type === "repair" ? "J&K Repair" : "J&K Trucking"}.`} />} />
      {type === "trucking" && <Route path="fleet" element={<Fleet businessId={businessId} />} />}
      {type === "trucking" && <Route path="fleet/:unitId" element={<FleetUnitDetail />} />}
      {type === "repair" && <Route path="parts" element={<Parts businessId={businessId} />} />}
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}
